<div id="contents" role="main" style="min-height: 395px;">
	<section class="flex_ctr_bx">
		<div class="check-container">
			<div class="check-left">
				<h2>Check Your<br/>Coverage Status</h2>
				<p style="margin-top:20px;">Please enter either the serial number or the contract number to check your coverage status.
					And you also need to enter your email address.
				</p>
					<div class="check-icon"><img src="./assets/images/arrow-right.png" width=30px ></div>
			</div>
			<div class="check-right">
				<div class="check-input-wrapper">
					<div [formGroup]="form" class="form_wrap type2 imei-email" #myForm="ngForm">
						<div class="radio-tab imei on">
							<div class="form_group data_type">
								<div class="tit">
									<label for="serialNumber">
										Serial Number<i class="ico_compulsory">*</i>
									</label>
								</div>
								<div class="txt right_gap">
									<span class="inp_wrap">
										<input type="text" [value]="form.value.serialNumber" formControlName='serialNumber'
										placeholder="Enter your Serial Number (ex.10NH1AKA912820K)"  limit-char="" limit="30" maxlength="30"
											id="serianNumber">
										<span class="focus-border"><i></i></span>
									</span>
									<span *ngIf="form.controls.serialNumber.dirty && form.controls.serialNumber.hasError('required')"
										class="warning">
										Please enter a serial number.
									</span>
									<span *ngIf="form.value.serialNumber && form.value.policyNumber" class="warning">
										Please enter either serial number or a contract number.
									</span>
								</div>
							</div>
						</div>
						<div class="radio-tab imei on">
							<div class="form_group data_type">
								<div class="tit nobg">
								</div>
								<div class="txt right_gap" style="text-align: center">
									<h1>OR</h1>
								</div>
							</div>
						</div>
						<div class="radio-tab imei on">
							<div class="form_group data_type">
								<div class="tit">
									<label for="policyNumber">
										Contract Number<i class="ico_compulsory">*</i>
									</label>
								</div>
								<div class="txt right_gap">
									<span class="inp_wrap">
										<input (keypress)="keyPressNumbersOnly($event)" type="tel" [value]="form.value.policyNumber"
											formControlName='policyNumber' placeholder="Enter your contract number (ex.643014474)" numbers-only="" limit-char=""
											limit="10" maxlength="10" id="policyNumber">
										<span class="focus-border"><i></i></span>
									</span>
									<span *ngIf="form.controls.policyNumber.dirty && form.controls.policyNumber.hasError('required')"
										class="warning">
										Please enter policy number.
									</span>
									<span *ngIf="form.value.serialNumber && form.value.policyNumber" class="warning">
										Please enter either serial number or a contract number.
									</span>
								</div>
							</div>
						</div>
						<div class="form_group data_type">
							<div class="find-text-left">
									&nbsp;
								<!-- <a href="https://www.samsung.com/us/support/#find-codes">How can I find Model Code and Serial Number?</a> -->
						</div>
						<div class="find-text">
							<!-- <a target="_blank" href="http://stgwebus.samsung.com/us/support/#find-codes">How can I find Serial Number?</a>  -->
							<a href="https://www.samsung.com/us/support/#find-codes">How can I find Serial Number?</a>
					</div></div>
						<div class="radio-tab imei on" style="border-top:1px solid #ddd; margin-top:20px; padding-bottom:10px;">
							<div class="form_group data_type"></div>
						</div>
						<div class="form_group data_type nospace">
							<div class="tit"><label for="emailOne">Email Address <i class="ico_compulsory">*</i></label>
							</div>
							<div class="txt right_gap">
								<span class="inp_wrap"><input type="email" [value]="form.value.emailOne" formControlName='emailOne'
										id="emailOne" placeholder="Enter email address">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.emailOne.dirty && form.controls.emailOne.hasError('required')" class="warning">
									Please enter email.
								</span>
								<span *ngIf="form.controls.emailOne.dirty && form.controls.emailOne.hasError('pattern')"
									class="warning">Please enter a valid email address.</span>
								<!--
								<span class="warning off" id=" contactEmail">Please enter your email address</span>
								<span class="warning off" id="contactEmailInvalid">Invalid email, please try again.</span>
								-->
							</div>
						</div>
						<!--div class="radio-tab imei on">
							<div class="form_group data_type"></div>
						</div-->
						<!-- <div class="btn_area only">
							<a class="btn btn_type1" [ngClass]="{'disable': !(form.value.serialNumber && form.value.emailOne && isRecaptchaSuccess)}" (click)="onCheckWithSerial()">Check with serial number</a>
						</div> -->
			
						<!--
						<div class="form_group data_type">
							<div class="tit"><label for="emailTwo">Email Address <i class="ico_compulsory">*</i></label>
							</div>
							<div class="txt right_gap">
								<span class="inp_wrap"><input type="email" [value]="form.value.emailTwo" formControlName='emailTwo' id="emailTwo"
										placeholder="Enter email address">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.emailTwo.dirty && form.controls.emailTwo.hasError('required')" class="warning">
									Please enter email.
								</span>
								<span *ngIf="form.controls.emailTwo.dirty && form.controls.emailTwo.hasError('pattern')" class="warning">Invalid
									email</span>
							</div>
						</div>
						<div class="btn_area only">
							<a class="btn btn_type1" [ngClass]="{'disable': !(form.value.policyNumber && form.value.emailTwo && isRecaptchaSuccess)}" (click)="oneCheckWithPolicy()">Check with policy number</a>
						</div>
						-->
						<div class="captcha_area">
							<div *ngIf="!isRecaptcharRestart">
								<ngx-recaptcha2 class="recaptcha2" [siteKey]="siteKey" (success)="onRecatcharSuccess($event)"
									(expire)="onRecaptchaExpired()" formControlName="recaptcha">
								</ngx-recaptcha2>
							</div>
						</div>
					</div>
				</div>
			
						<!-- <div class="btn_area only">
							<a class="btn btn_type1"
								[ngClass]="{'disable': !(form.value.modelCode && form.value.serialNumber && isRecaptchaSuccess)}"
								(click)="onCheck()">Check</a>
						</div> -->
						
						
				
	
			</div>
		</div>
		<div class="btn_area only">
			<!-- <a class="btn btn_type1"
				[ngClass]="{'disable': !((form.value.serialNumber || form.value.policyNumber) && form.value.emailOne && isRecaptchaSuccess)}"
				myForm.form.valid
				(click)="onNext()">Next</a> -->
			<a class="btn btn_type1"
				[ngClass]="{'disable': !(!(form.value.serialNumber && form.value.policyNumber) && (form.value.serialNumber || form.value.policyNumber) && !form.controls.emailOne.hasError('pattern') && isRecaptchaSuccess)}"
				(click)="onNext()">Submit<img src="./assets/images/button-arrow.png"></a>
		</div>
	</section>
</div>